
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-dls.cjs.production.min.js')
} else {
  module.exports = require('./react-dls.cjs.development.js')
}
